import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import LoaderComponent from "./LoaderComponent";
import {
  getAuthenticatedHomeRoute,
  getAuthToken,
  hasAuthenticatedUserData,
  isOrganisationGroupUser,
} from "../../Util/authRedirect";

const ProtectedRotes = () => {
  const rehydrated = useSelector((state) => state?.authSlice?._persist?.rehydrated);
  const dataofstore = useSelector((state) => state?.authSlice.userData?.payload);
  const authToken = getAuthToken(dataofstore);

  if (!rehydrated) return <LoaderComponent />;

  if (!authToken) return <Navigate to="/" replace />;

  if (!hasAuthenticatedUserData(dataofstore)) return <LoaderComponent />;

  return dataofstore?.role !== "Teacher" && !isOrganisationGroupUser(dataofstore) ? (
    <Outlet />
  ) : (
    <Navigate to={getAuthenticatedHomeRoute(dataofstore)} replace />
  );
};

export default ProtectedRotes;
